import { capitalize } from 'lodash';

import { formatValue, renderEdition } from './common';

import type { ChangelogRule } from './types';

export const ADVANCED_CPM_ORDER = 1500;

export const advancedCpmRules: ChangelogRule[] = [
  {
    format: (change, context) =>
      renderEdition(
        `${context.entity} ${context.formatMessage({
          defaultMessage: 'Advanced CPM Option',
          id: 'changelogModal.message.advanced'
        })} ${capitalize(String(change.path?.[1] ?? ''))}`,
        formatValue(change.lhs),
        formatValue(change.rhs),
        context
      ),
    order: ADVANCED_CPM_ORDER,
    regex: /^E\.advancedCpmOptions(\.|$)/,
    section: 'advancedCpm'
  }
];
